import React from "react";
import { useTranslation } from "react-i18next";
import { Identifiable } from "../../../models/Identifiable";
import getId from "../../../../utils/getId";
import HtmlTooltip from "@mui/material/Tooltip";

interface IProps {
  humanName: string;
  humanPicture: string;
  deputyHumanIds: Identifiable;
  deputyHumanName: string;
  deputyHumanLastName: string;
}

const CoachInfoAssort: React.FC<IProps> = ({
  humanName,
  humanPicture,
  deputyHumanIds,
  deputyHumanName,
  deputyHumanLastName,
}) => {
  const { t } = useTranslation();

  if (humanName && humanName.length > 1) {
    return (
      <HtmlTooltip
        placement="bottom-start"
        title={
          <>
            <article
              className="tooltip-description"
              dangerouslySetInnerHTML={{
                __html:
                  "Trener przypisany do tej godziny odpowiada za prowadzenie zajęć, opiekę nad grupą i dostosowanie ćwiczeń do uczestników.",
              }}
            ></article>
          </>
        }
      >

        
        <b className="alert alert-gray">
          {/* {t("trener_opiekun")}:{" "} */}
          {getId(deputyHumanIds) ? (
            <>
              {/* <EAAlert type="warning" message={t("zastepstwo")} compact /> */}
              <b>
             
                <s>{humanName}</s> {deputyHumanName} {deputyHumanLastName}
              </b>
            </>
          ) : (
          <>
          {humanPicture ? (  <div
          className={`coach-img ${humanPicture.length <= 1 ? "coach-img-none" : ""}`}
          style={humanPicture.length ? { backgroundImage: `url(${humanPicture})` } : undefined}
        />) : (<>{t("trener_opiekun")}: {" "}</>)}
  
            <b>{humanName}</b>
          </>
          
          )}
        </b>
      </HtmlTooltip>
    );
  }

  return <></>;
};

export default CoachInfoAssort;